export default {"src":"/_next/static/media/trust-pilot-single-star.961b64bf.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};